
// Get the current time in Eastern Time Zone (ET)
  let currentTimeInET = moment().tz('America/New_York');

  // Get the current day of the week in Eastern Time Zone (ET) in ISO 8601 format (%u)
  let currentDayOfWeekInET = currentTimeInET.isoWeekday();

  // Get the current hour in Eastern Time Zone (ET) in 24-hour format (%H)
  let currentHourInET = currentTimeInET.hour();

  // Output the current day of the week in Eastern Time Zone (ET) in ISO 8601 format (%u)
  console.log("Current day of the week in Eastern Time Zone (ET) (ISO 8601 format): " + currentDayOfWeekInET);

  // Output the current hour in Eastern Time Zone (ET) in 24-hour format (%H)
  console.log("Current hour in Eastern Time Zone (ET) (24-hour format): " + currentHourInET);

// leaving the variable as isAfter8AM even though the store now opens at 7am
  let isAfter8AM = false
  if ( currentHourInET  >= 7 ) {
    isAfter8AM = true
  }

// leaving the variable as isBefore9PM even though the store now closes at midnight
    let isBefore9PM = false
  if ( currentHourInET  < 24 ) {
    isBefore9PM = true
  }

      let isAfter8AMandisThursday = false
  if ( isAfter8AM && (currentDayOfWeekInET == 4) ) {
    isAfter8AMandisThursday = true
  }

        let isBefore9PMandisSunday = false
  if ( isBefore9PM && (currentDayOfWeekInET == 7) ) {
    isBefore9PMandisSunday = true
  }

  let canOrder = false
    if ( isAfter8AMandisThursday || (currentDayOfWeekInET == 5) || (currentDayOfWeekInET == 6) || isBefore9PMandisSunday ) {
    canOrder = true
  }